// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__StIM1","notes":"Notes_notes__WA2PG","note":"Notes_note__2x5L4","markdown":"Notes_markdown__3847G"};